import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { NewsPlusSVG } from '@common_components/svg/newsPlus.svg';

const NewsPlusIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <NewsPlusSVG/>
    </div>
  );
};

export { NewsPlusIcon };
